import { render, staticRenderFns } from "./RelatedEntitlements.vue?vue&type=template&id=062b29d8&"
import script from "./RelatedEntitlements.vue?vue&type=script&lang=js&"
export * from "./RelatedEntitlements.vue?vue&type=script&lang=js&"
import style0 from "./RelatedEntitlements.vue?vue&type=style&index=0&id=062b29d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports